export default [
    {
        name: 'notice',
        path: 'notice',
        meta: { title: '公告管理' },
        component: ()=>import('@/pages/notice/index.vue')
    }
]